import { Card, CardContent } from '@/components/ui/card'
import { Settings, Clock, TrendingUp, Calculator } from 'lucide-react'
import { useI18n } from '@/store/I18nContext'

export function PricingRules() {
  const { t } = useI18n()

  const features = [
    {
      icon: Calculator,
      title: t('price.f1Title'),
      desc: t('price.f1Desc'),
    },
    {
      icon: Clock,
      title: t('price.f2Title'),
      desc: t('price.f2Desc'),
    },
    {
      icon: TrendingUp,
      title: t('price.f3Title'),
      desc: t('price.f3Desc'),
    },
    {
      icon: Settings,
      title: t('price.f4Title'),
      desc: t('price.f4Desc'),
    },
  ]

  return (
    <section className="py-20" id="precos">
      <div className="container mx-auto px-4 text-center max-w-4xl">
        <h2 className="text-3xl md:text-5xl font-extrabold tracking-tighter mb-4 leading-tight">
          {t('price.title')}
        </h2>
        <p className="text-lg text-muted-foreground mb-12 leading-relaxed font-medium">
          {t('price.subtitle')}
        </p>

        <div className="grid sm:grid-cols-2 gap-6 text-left">
          {features.map((feature, i) => (
            <Card
              key={i}
              className="border bg-card shadow-sm hover:shadow-md hover:border-primary/50 transition-all group"
            >
              <CardContent className="p-6 flex items-start gap-4">
                <div className="bg-primary/10 p-3 rounded-lg text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors">
                  <feature.icon className="h-6 w-6" />
                </div>
                <div>
                  <h3 className="font-bold tracking-tight text-xl mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-sm text-muted-foreground leading-relaxed font-medium">
                    {feature.desc}
                  </p>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}
